/**
 * Generates placeholder style for each of the browsers supported by `@fluentui/react`.
 * @param styles - The style to use.
 * @returns The placeholder style object for each browser depending on the placeholder directive it uses.
 */
export function getPlaceholderStyles(styles) {
  return {
    selectors: {
      '::placeholder': styles,
      ':-ms-input-placeholder': styles,
      '::-ms-input-placeholder': styles // Edge
    }
  };
}